(function () {
  var pending = null;

  function replayCardAnimation() {
    // Force re-run of the CSS stagger animation after AJAX swap
    var cards = document.querySelectorAll('.main-archive__grid .card-archive');
    cards.forEach(function (c) {
      c.style.animation = 'none';
      void c.offsetWidth; // reflow
      c.style.animation = '';
    });
  }

  function applySort(href) {
    if (pending) { pending.abort(); pending = null; }
    var ctrl = new AbortController();
    pending = ctrl;
    history.pushState({}, '', href);

    var grid = document.getElementById('ArchiveGridContainer');
    if (grid) {
      grid.style.cssText = 'opacity:0;transform:translateY(-6px);transition:opacity 0.22s ease,transform 0.22s ease';
    }

    fetch(href, { signal: ctrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('ArchiveGridContainer');
        var curr = document.getElementById('ArchiveGridContainer');
        if (next && curr) {
          curr.innerHTML = next.innerHTML;
          curr.style.cssText = 'opacity:0;transform:translateY(6px);transition:none';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              curr.style.cssText = 'opacity:1;transform:translateY(0);transition:opacity 0.5s ease,transform 0.5s cubic-bezier(0.22,1,0.36,1)';
              replayCardAnimation();
            });
          });
        }
        pending = null;
      })
      .catch(function () {
        if (grid) grid.style.cssText = '';
      });
  }

  function closeSort() {
    var w = document.querySelector('[data-archive-sort-wrapper]');
    if (!w) return;
    w.classList.remove('is-open');
    var t = w.querySelector('[data-archive-sort-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  if (!window.__archiveListenersInstalled) {
    window.__archiveListenersInstalled = true;

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-archive-sort-link]');
      var trigger = e.target.closest('[data-archive-sort-trigger]');

      if (link) {
        e.preventDefault();
        e.stopPropagation();
        applySort(link.getAttribute('href'));
        closeSort();
        return;
      }

      if (trigger) {
        var wrapper = trigger.closest('[data-archive-sort-wrapper]');
        var isOpen = wrapper.classList.contains('is-open');
        wrapper.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        return;
      }

      if (!e.target.closest('[data-archive-sort-wrapper]')) {
        closeSort();
      }
    });
  }
})();
